// extracted by mini-css-extract-plugin
export var bodySections = "_ay-8";
export var gray = "_ay-7";
export var green = "_ay-4";
export var iconContainer = "_ay-9";
export var iconWidgetContainer = "_ay-1";
export var phoneIcon = "_ay-2";
export var red = "_ay-5";
export var statusDot = "_ay-3";
export var widgetContainer = "_ay-0";
export var yellow = "_ay-6";